<div class="">
    <div class="header">
        @if (modaltype == 'touchPoint') {
            <span>Schedule Follow-Up</span>
        } @else if (modaltype == 'history') {
            <span>Log History</span>
        } @else {
            <span>{{form.get('subject')?.value}}</span>
        }
        <button type="button" (click)="close()"><i class="fas fa-close text-gray-500 text-lg"></i></button>
    </div>
    <div class="content_log">
        <form [formGroup]="form">
            <div class="info">
                <div class="customer">
                    <p class="customer_name">{{form.get('creator')?.value?.name}}</p>
                    <div class="customer_contacts" [ngClass]="{
                        'pointer-events-none': form.get('sent')?.value == true
                    }">
                        @if (contact?.phones?.length) {
                            <div [ngClass]="{
                                'hidden': form.get('sent')?.value == true && form.get('types')?.value?.includes('Email')
                            }">
                                @for(phone of contact?.phones; track $index) {
                                    @if (phone?.value) {
                                        <div class="customer_contac_item">
                                            <input (change)="onPhoneCheckboxChange($event, $safeNavigationMigration(phone?.value))" [id]="$safeNavigationMigration(phone?.value)" type="checkbox" [disabled]="isLandlinePhone(phone) && smsSelected" [checked]="$safeNavigationMigration(form.get('phones')?.value?.includes($safeNavigationMigration(phone?.value)))" class="custom-checkbox text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                            @if (phone?.isUnsubscribed) {
                                                <i class="fa-solid fa-paper-plane input-icon text-red-400" title="Phone was unsubscribed"></i>
                                            }
                                            @if (isLandlinePhone(phone)) {
                                                <i class="fa-solid fa-phone-volume input-icon text-gray-400" title="Landline — can't receive SMS"></i>
                                            }
                                            <label [for]="$safeNavigationMigration(phone?.value)">{{applyMask($safeNavigationMigration(phone?.value), inputMasks.phone)}}</label>
                                        </div>
                                    }
                                }
                            </div>
                        }

                        @if (contact?.emails?.length) {
                            <div [ngClass]="{
                                'hidden': form.get('sent')?.value == true && form.get('types')?.value?.includes('SMS')
                            }">
                                @for(email of contact?.emails; track $index) {
                                    @if (email?.value) {
                                        <div class="customer_contac_item">
                                            <input (change)="onEmailCheckboxChange($event, $safeNavigationMigration(email?.value))" [id]="$safeNavigationMigration(email?.value)" [checked]="$safeNavigationMigration(form.get('emails')?.value?.includes($safeNavigationMigration(email?.value)))" type="checkbox" class="custom-checkbox text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                            @if (email?.isUnsubscribed) {
                                                <i class="fa-solid fa-paper-plane input-icon text-red-400" title="Email was unsubscribed"></i>
                                            }
                                            <label [for]="$safeNavigationMigration(email?.value)">{{truncateString($safeNavigationMigration(email?.value))}}</label>
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                    @if (
                    (emailsPhonesWarning && form.get('emails')?.invalid && form.get('phones')?.invalid) ||
                    (form.get('types')?.value?.includes('Email') && !form.get('emails')?.value?.length) ||
                    (form.get('types')?.value?.includes('SMS') && !form.get('phones')?.value?.length) ||
                    (form.get('types')?.value?.includes('Call') && !form.get('phones')?.value?.length)
                    ) {
                        <p class="please_select">Please select email / phone</p>
                    }
                </div>
                <div class="select_cont">
                    <div class="select_cont_item cont_item_btns">
                        @if (modaltype == 'history' || modaltype == 'touchPoint' || modaltype == 'edit_empty_schedule' || isFollowUp) {
                            <div class="touchpoints">
                                @if (!form.get('sentNow').value) {
                                    <button
                                    class="touchpoint_item"
                                    (click)="onChangeTypes('Call')"
                                    [ngClass]="{'active_coin_btn': $safeNavigationMigration(this.form.get('types').value?.includes('Call')), 'no_active_coin_btn': !this.form.get('types').value?.includes('Call')}"
                                >
                                    Call
                                </button>
                                }
                                <button
                                    class="touchpoint_item"
                                    (click)="onChangeTypes('SMS')"
                                    [ngClass]="{'active_coin_btn': $safeNavigationMigration(this.form.get('types').value?.includes('SMS')), 'no_active_coin_btn': !this.form.get('types').value?.includes('SMS')}"
                                >
                                    SMS
                                </button>
                                <button
                                    class="touchpoint_item"
                                    (click)="onChangeTypes('Email')"
                                    [ngClass]="{'active_coin_btn': $safeNavigationMigration(this.form.get('types').value?.includes('Email')), 'no_active_coin_btn': !this.form.get('types').value?.includes('Email')}"
                                >
                                    Email
                                </button>
                            </div>
                        }
                        @if (modaltype == 'history') {
                            <div class="directions">
                                <button
                                    class="touchpoint_item"
                                    (click)=" this.form.get('direction')?.setValue('Inbound')"
                                    [ngClass]="{'active_coin_btn': this.form.get('direction').value == 'Inbound', 'no_active_coin_btn': this.form.get('direction').value !== 'Inbound'}"
                                >
                                    Inbound
                                </button>
                                <button
                                    class="touchpoint_item"
                                    (click)=" this.form.get('direction')?.setValue('Outbound')"
                                    [ngClass]="{'active_coin_btn': this.form.get('direction').value == 'Outbound', 'no_active_coin_btn': this.form.get('direction').value !== 'Outbound'}"
                                >
                                    Outbound
                                </button>
                            </div>
                        }
                        @if (modaltype == 'edit' && !isFollowUp) {
                            <app-input
                                [idInfo]="'touchpoint'"
                                [value]="types"
                                [isReadOnly]="true"
                                [label]="'Touchpoint'"
                            ></app-input>
                        }
                    </div>
                    <div class="select_types">
                        @if (
                            (typesWarning && form.get('types')?.invalid && !form.get('types')?.value?.length)
                        ) {
                            <p class="please_select" style="margin-top: 0px;">Please select Touch Point</p>
                        }
                    </div>
                    <div class="flex items-center select_cont_dates select_cont_item" [ngClass]="{
                        'pointer-events-none': form.get('sent')?.value == true
                    }">
                        @if (!form.get('sentNow').value) {
                            <app-date
                                id="task-follow-up-date"
                                [isContainerStyle]="true"
                                [options]="{ placeholder: 'Date', right: '90px', required: dateWarning && this.form.get('sentAt')?.invalid }"
                                [parent]="form.value"
                                [time]="true"
                                [startKey]="'sentAt'"
                                (onSave)="form.patchValue({'sentAt': $event})"
                            ></app-date>
                        }
                    </div>
                    @if ((modaltype == 'edit' || modaltype == 'history') && !noTag) {
                        <div class="select_cont_item">
                            <div class="outcomes">
                                @for(tag of outcomeGreen; track $index) {
                                    <button
                                        class="outcome_item"
                                        (click)="onChangeOutcome($safeNavigationMigration(tag?.name))"
                                        [ngStyle]="{'color:': $safeNavigationMigration(tag?.color), 'background': this.form.get('tag').value !== tag?.name ? $safeNavigationMigration(tag?.bg) : null}"
                                        [ngClass]="{'active_outcome_green': this.form.get('tag').value == tag?.name}"
                                    >
                                        {{tag?.name}}
                                    </button>
                                }
                            </div>
                            <div class="outcomes">
                                @for(tag of outcomeYellow; track $index) {
                                    <button
                                        class="outcome_item"
                                        (click)="onChangeOutcome($safeNavigationMigration(tag?.name))"
                                        [ngStyle]="{'color:': $safeNavigationMigration(tag?.color), 'background': this.form.get('tag').value !== tag?.name ? $safeNavigationMigration(tag?.bg) : null}"
                                        [ngClass]="{'active_outcome_yellow': this.form.get('tag').value == tag?.name}"
                                    >
                                        {{tag?.name}}
                                    </button>
                                }
                            </div>
                            <div class="outcomes">
                                @for(tag of outcomeRed; track $index) {
                                    <button
                                        class="outcome_item"
                                        (click)="onChangeOutcome($safeNavigationMigration(tag?.name))"
                                        [ngStyle]="{'color:': $safeNavigationMigration(tag?.color), 'background': this.form.get('tag').value !== tag?.name ? $safeNavigationMigration(tag?.bg) : null}"
                                        [ngClass]="{'active_outcome_red': this.form.get('tag').value == tag?.name}"
                                    >
                                        {{tag?.name}}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div class="template_name" [ngClass]="{
                'pointer-events-none': form.get('sent')?.value == true
            }">
                @if (form.get('types')?.value?.length) {
                    <app-input
                        [idInfo]="'subject'"
                        [label]="'Subject'"
                        [value]="$safeNavigationMigration(form.get('subject')?.value)"
                        (onChange)="form.patchValue({
                            subject: $event
                        })"
                    ></app-input>
                }
                @if (form.get('types')?.value?.includes('SMS') || form.get('types')?.value?.includes('Email')) {
                    <app-select
                        [label]="'Template'"
                        [idInfo]="'template-name'"
                        (onSave)="changeTemplate($event)"
                        [value]="$safeNavigationMigration(form.get('templateId')?.value)"
                        [list]="templates"
                        [keyName]="{key:'_id', name:'name'}"
                        [placeholder]="'Sub'"
                    ></app-select>
                }
            </div>
            @if (form.get('types')?.value?.includes('Call')) {
                <div class="descr flex flex-col">
                    @if (!editHistory) {
                        <span class="templ_title">Schedule Call</span>
                    }
                    <textarea
                        id="message"
                        rows="4"
                        formControlName="description"
                        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Internal Notes"
                    ></textarea>
                </div>
            }
            @if (form.get('types')?.value?.includes('SMS') || form.get('types')?.value?.includes('Email')) {
                <div class="templates" [ngClass]="{
                    'edit_sms_email': (this.form.get('filteredTypes').value[0] == 'Email' || this.form.get('filteredTypes').value[0] == 'SMS') && this.form.get('filteredTypes').value?.length == 1
                }">
                    @if (form.get('types')?.value?.includes('SMS')) {
                        <div class="template_item">
                            <span class="templ_title">SMS</span>
                            @if (form.get('sent')?.value == true) {
                                <div class="email_body_view">
                                    <div [innerHTML]="$safeNavigationMigration(form.get('smsBody')?.value)"></div>
                                </div>
                            } @else {
                                <div class="editor_sms" [ngClass]="{'input_invalid': smsWarning && this.form.get('smsBody')?.invalid}">
                                    <textarea
                                        id="sms"
                                        rows="8"
                                        formControlName="smsBody"
                                        style="resize: none;"
                                        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder="SMS message..."
                                    ></textarea>
                                </div>
                            }
                        </div>
                    }
                    @if (form.get('types')?.value?.includes('Email')) {
                        <div class="template_item">
                            <span class="templ_title">Email</span>
                            @if (form.get('sent')?.value == true) {
                                <div class="email_body_view">
                                    <div class="email-paper" style="padding: 12px;" [innerHTML]="$safeNavigationMigration(form.get('emailBody')?.value)"></div>
                                </div>
                            } @else {
                                <div class="editor" [ngClass]="{'input_invalid': emailWarning && this.form.get('emailBody')?.invalid}">
                                    <app-editor [mode]="'editor'" [ngClass]="{'editor_full': this.form.get('filteredTypes').value[0] == 'Email' && this.form.get('filteredTypes').value?.length == 1, 'editor_full_email': this.form.get('filteredTypes').value.includes('Email') && this.form.get('filteredTypes').value.includes('SMS')}" [content]="$safeNavigationMigration(form.get('emailBody')?.value)" (onChange)="form.patchValue({
                                        emailBody: $event
                                    })"></app-editor>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
            @let showFillTemplateLater = (!isTask || modaltype == 'edit_empty_schedule') && !editHistory && (!form.get('sentNow').value);
            <div class="btns"
            [ngClass]="{
                'edit_sms_email_btn': !((this.form.get('filteredTypes').value[0] == 'Email' || this.form.get('filteredTypes').value[0] == 'SMS') && this.form.get('filteredTypes').value?.length == 1)
            }">
            @if(modaltype != 'history' && form.get('types')?.value?.includes('SMS')){
                <div class="w-fit flex items-center flex-wrap gap-2"
                [class.mr-2]="(this.form.get('filledLater').value || this.form.get('sentNow').value) && modaltype == 'edit' && canDelete">
                    @if(!editHistory && currentUser?.integrations?.ringCentral?.senderPhoneNumber){
                        <app-btn-toggle
                            [idInfo]="'use-ring-central-phone-toggle'"
                            [label]="'Send From Ring Central Phone'"
                            [value]="this.form.get('sendFrom').value === 'ring-central'"
                            (onToggle)="this.form.patchValue({ sendFrom: $event ? 'ring-central' : null })"
                        ></app-btn-toggle>
                        <span class="text-gray-400" style="font-size: 12px;">{{$safeNavigationMigration(currentUser?.integrations?.ringCentral?.senderPhoneNumber) | phone : true}}</span>
                    }
                    @if(!editHistory && currentUser?.integrations?.dialpad?.hasCompanyToken && currentUser?.integrations?.dialpad?.senderPhoneNumber){
                        <app-btn-toggle
                            [idInfo]="'use-dialpad-phone-toggle'"
                            [label]="'Send From Dialpad Phone'"
                            [value]="this.form.get('sendFrom').value === 'dialpad'"
                            (onToggle)="this.form.patchValue({ sendFrom: $event ? 'dialpad' : null })"
                        ></app-btn-toggle>
                        <span class="text-gray-400" style="font-size: 12px;">{{$safeNavigationMigration(currentUser?.integrations?.dialpad?.senderPhoneNumber) | phone : true}}</span>
                    }
                </div>
            }
                @if (modaltype == 'edit' && canDelete) {
                    <button class="delete" (click)="deleteFollowUp(form.value)"
                    [class.mr-2]="currentUser?.integrations?.ringCentral?.senderPhoneNumber">Delete</button>
                }
                <div class="ml-auto">
                    @if (showFillTemplateLater) {
                        <app-btn-toggle
                            [value]="this.form.get('filledLater').value"
                            [label]="'Fill Template Later'"
                            [idInfo]="'later-toggle'"
                            (onToggle)="this.form.patchValue({filledLater: $event}); form.get('sentNow').value ? form.patchValue({sentNow: false}) : null"
                        >
                        </app-btn-toggle>
                    }
                </div>
                @if ((modaltype == 'touchPoint' || modaltype == 'edit' || modaltype == 'edit_empty_schedule') && !this.form.get('filledLater').value && !editHistory && !isTask) {
                  <div class="sent-now">
                      <app-btn-toggle
                          [value]="this.form.get('sentNow').value"
                          [label]="'Send Now'"
                          [idInfo]="'sent-now-toggle'"
                          (onToggle)="this.form.patchValue({sentNow: $event}); form.get('filledLater').value ? form.patchValue({filledLater: false}) : null"
                      >
                      </app-btn-toggle>
                    </div>
                  }
                <button class="cancel" (click)="close()">Cancel</button>
                @if (modaltype == 'edit') {
                    <button class="log_activity" (click)="send()">Save</button>
                } @else if (modaltype == 'history') {
                    <button class="log_activity" (click)="send()">Log History</button>
                } @else {
                    <button class="log_activity_schedule" (click)="send()">Schedule {{this.form.get('types')?.value?.length || 0}} Events</button>
                }
            </div>
        </form>
    </div>
</div>
